import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";

export const V9JennyNight = async (): Promise<any> => {
    //ImageClass.setImage(images.TODO_IMAGE)

    mc.talk(`TODO: V9JennyNight`);
    //return jump(V9JennyNightAfter, "V9JennyNightAfter");
};